import { User, UserDetailedInfo } from "@/types";

import { axios } from "../axios.instance";

export type AppleAuthRequest = {
  authorizationCode: string;
  role?: User["role"];
  affiliateCode?: string;
};

export type AppleAuthResponse = {
  user: User & UserDetailedInfo;
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
};

export const appleAuth = async (body: AppleAuthRequest): Promise<AppleAuthResponse> => {
  const { data } = await axios.post("auth/socials/apple/login", body);

  return data;
};
